// extracted by mini-css-extract-plugin
export default {"content":"contact_content__qbnjK","form":"contact_form__39IdR"};